interface ColumnFormat {
  getColumnIndex(type: string): number
}

const ColumnTypes = ["Date", "Counterparty", "Account", "Amount"];

class CustomizedFormat implements ColumnFormat {
  private _dict: Record<number, string>;

  constructor(dict: Record<number, string>) {
    this._dict = dict;
  }

  getColumnIndex(type: string): number {
    const index = Object.entries(this._dict)
      .filter(ent => ent[1] === type)
      .map(ent => ent[0]);
    if (index.length === 0) {
      throw new Error("No column defined");
    }
    return parseInt(index[0]);
  }
}

class LedgerCliExportFormat implements ColumnFormat {
  private _format: Record<number, string> = {
    0: "Date",
    2: "Counterparty",
    3: "Account",
    5: "Amount"
  }

  getColumnIndex(type: string): number {
    const index = Object.entries(this._format)
      .filter(ent => ent[1] === type)
      .map(ent => ent[0]);
    if (index.length === 0) {
      throw new Error("No column defined");
    }
    return parseInt(index[0]);
  }
}

export { ColumnFormat, CustomizedFormat, LedgerCliExportFormat, ColumnTypes }